export class ResourceManagementNavigationModule {

    static get GroupsManagement(): string { return `${ResourceManagementNavigationModule.ParentRoot}.groups`; }
    static get VehiclesManagement(): string { return `${ResourceManagementNavigationModule.ParentRoot}.vehicles`; }
    static get DriversManagement(): string { return `${ResourceManagementNavigationModule.ParentRoot}.drivers`; }
    static get UsersManagement(): string { return `${ResourceManagementNavigationModule.ParentRoot}.users`; }

    static get CameraManagement(): string { return `${ResourceManagementNavigationModule.ParentRoot}.cameras` }
    static get Settings(): string { return `${ResourceManagementNavigationModule.ParentRoot}.settings`; }
    static get ContextualSpeedingSettings(): string { return `${ResourceManagementNavigationModule.ParentRoot}.contextualspeedingsettings`; }

    static get DeviceProfilesManagement(): string { return `${ResourceManagementNavigationModule.ParentRoot}.driveprofiles`; }
    static get EditDeviceProfile(): string { return `${ResourceManagementNavigationModule.DeviceProfilesManagement}.edit`; }
    static get NewDeviceProfile(): string { return `${ResourceManagementNavigationModule.DeviceProfilesManagement}.new`; }

    static get DrivingStylesManagement(): string { return `${ResourceManagementNavigationModule.ParentRoot}.drivingstyles`; }
    static get EditDrivingStyle(): string { return `${ResourceManagementNavigationModule.DrivingStylesManagement}.edit`; }
    static get NewDrivingStyle(): string { return `${ResourceManagementNavigationModule.DrivingStylesManagement}.new`; }

    static get Default(): string { return ResourceManagementNavigationModule.GroupsManagement; }
    static get ParentRoot(): string { return "app.resourceManagement"; }
}
